import type { ActivityLocationPayload } from "../repositories/activitiesRepository";

const LOCATION_EDIT_FIELDS = ["isInTerreiro", "location"];

export const isActivityLocationPayload = (
  value: unknown,
): value is ActivityLocationPayload =>
  Boolean(value) &&
  typeof value === "object" &&
  !Array.isArray(value) &&
  typeof (value as ActivityLocationPayload).isInTerreiro === "boolean";

/** Review and edit labels. In the terreiro, the nickname stays off this line. */
export const formatActivityChatLocationLabel = (
  location?: ActivityLocationPayload,
): string => {
  if (!location || location.isInTerreiro !== false) return "No terreiro";
  const label = [
    location.street,
    location.number,
    location.neighborhood,
    location.city,
    location.state,
  ]
    .map((part) => (typeof part === "string" ? part.trim() : ""))
    .filter(Boolean)
    .join(", ");
  return label || "Endereço externo";
};

/**
 * Terreiro chats ask where the activity or ritual happens, including templates.
 * Personal chats never ask. An in-terreiro answer has no separate address step.
 */
export const resolveHiddenActivityLocationFields = ({
  isInTerreiro,
  isPersonalProfile,
}: {
  isInTerreiro: unknown;
  isPersonalProfile: boolean;
}): Set<string> => {
  if (isPersonalProfile || typeof isInTerreiro !== "boolean") {
    return new Set(LOCATION_EDIT_FIELDS);
  }
  return new Set(isInTerreiro ? ["location"] : []);
};
